import React from 'react';
import moment from 'moment';

import StyledComponent from '~/components/Styled/Styled';

import ResultsMap from '~/constants/ResultsMap';

import getOr from '~/util/getOr';

import convertSnakeCaseToTitleCase from '~/util/convertSnakeCaseToTitleCase';

import css from './ResultsMatchupDescriptionCard.scss';

type Props = {
  event: any;
};

class ResultsMatchupDescriptionCard extends React.Component<Props> {
  static displayName = 'ResultsMatchupDescriptionCard';

  eventStatus = getOr(this.props, 'event.event_status', '');

  formatDescriptions(descriptionElement, event) {
    const propertyKeys = getOr(descriptionElement, 'properties', []);
    const format = getOr(descriptionElement, 'format', null);
    const seperator = getOr(descriptionElement, 'seperator', '');
    const label = getOr(descriptionElement, 'label', '');
    const eventStatus = getOr(descriptionElement, 'event_status', []);
    let properties = propertyKeys.map(propertyKey => getOr(event, propertyKey, null));
    if (eventStatus.length && !eventStatus.includes(this.eventStatus)) {
      return null;
    }
    switch (descriptionElement.type) {
      case 'date':
        properties = properties.map(property => moment(property).format(format));
        break;
      case 'text':
        if (format) {
          let description = format;
          properties.forEach((property, i) => {
            description = description.replace(`%[${i}]`, property);
          });
          return `${label}${label && ': '}${description}`;
        }
        break;
      default:
        break;
    }
    return `${label}${label && ': '}${properties.join(seperator)}`;
  }

  render() {
    const leagueSlug = getOr(this.props, 'event.league.slug', '');
    const name = getOr(this.props, 'event.name', '');
    const descriptionElementsKey = `[${leagueSlug}].matchupDescriptionElements`;
    const descriptionElements = getOr(ResultsMap, descriptionElementsKey, []);
    const isTennis = leagueSlug === 'atp' || leagueSlug === 'wta';

    if (isTennis && this.props.event.ground_type) {
      this.props.event.ground_type = convertSnakeCaseToTitleCase(this.props.event.ground_type);
    }

    return (
      <div className={css.matchupDescriptionContainer}>
        <div>
          <div className={css.eventName}>{name}</div>
          {this.eventStatus === 'in_progress' && <div className={css.statusLive}>LIVE</div>}
        </div>
        <div className={css.descriptionElementsContainer}>
          {descriptionElements.map(descriptionElement => {
            const key = getOr(descriptionElement, 'properties[0]', '');
            return (
              <div className={css.descriptionElement} key={key}>
                {this.formatDescriptions(descriptionElement, this.props.event)}
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}

export default StyledComponent(ResultsMatchupDescriptionCard, [css]);
